import { ApiService } from "./ApiService"

export class OltService {

    static uri = '/olt';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        }
        );
    }

    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
                }
            }
        );
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {},
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    static locationUpdate({ id, data }) {
        return ApiService.post(`${this.uri}/location-update/${id}`, data,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
                }
            }
        );
    }
}